<template>
  <div class="page">
    <div class="container article" >
      <router-link :to="{name:'creditoring',params: {section:'articles'}}" class="btn btn--white article__back">Retour aux articles</router-link>
      <div v-html="article" class="article__content"></div>
    </div>
  </div>
</template>

<script>

import {useRoute} from 'vue-router';
import { ref } from '@vue/reactivity';

import showdown from 'showdown';

export default {
  setup(){
    const route= useRoute();
    const routeName = route.params.name;

    const article = ref(null)

    // Vanilla JS
      var httpRequest = new XMLHttpRequest()
      httpRequest.onreadystatechange = function (data) {
        const converter = new showdown.Converter({noHeaderId: true});
        article.value = converter.makeHtml(data.target.response);
      }
      httpRequest.open('GET',`/articles/${routeName}.md`)
      httpRequest.send()

    return {article}
  }
}
</script>

<style lang="scss">
@import '@/style/main';

.article{

  padding-top: 3rem !important;
  @include respond(phone){
    padding: 3rem 2rem;
  }
  display: flex;
  flex-direction: column;

  align-items: flex-start;

  &__content{
    width: 100%;
    padding: 4rem 0;
  }

  &__back{
    margin-bottom: 0rem;
  }
 

  & h1{
    color:$color-primary;
    margin-bottom: 1rem;
    font-weight: 900;
    text-transform: uppercase;
    letter-spacing: .1rem;
  }

  & h2, h3, h4{
    margin: 2rem 0 1rem 0;
  }

  & h2{
    text-transform: uppercase;
    letter-spacing: .1rem;
  }

  & h4{
    font-size: 1.5rem;
  }

  & img{
    width: 50%;
    margin: 0 auto;
  }

  & ul, ol{
    margin-left: 1.5rem;
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  & li{
    padding-left: 1rem;
    &:not(:last-child){
      margin-bottom: .6rem;
    }
  }

  & p{
    text-align: justify;
    margin-bottom: 1rem;
  }

  & blockquote{

    & h2, h3, h4{
      margin-top: 0;
    }

    border-left: 6px solid $color-primary;
    padding: 1.4rem 2.5rem;

    box-shadow: $shadow;
    & p{
      margin-bottom: 0rem;
      line-height: 2rem;
    }
    margin: 3rem 0;
  }

  & hr{
    margin: 2rem 0;
  }
}

</style>